export var CLASS;
(function (CLASS) {
    CLASS["FROZEN"] = "frozen";
    CLASS["SCROLLED"] = "scrolled";
    CLASS["SCROLL_END"] = "scroll-end";
    CLASS["HAS_SCROLL"] = "has-scroll";
})(CLASS || (CLASS = {}));
